import { render } from "./ProductTop.vue?vue&type=template&id=68e5d127&scoped=true"
import script from "./ProductTop.vue?vue&type=script&lang=js"
export * from "./ProductTop.vue?vue&type=script&lang=js"

import "./ProductTop.vue?vue&type=style&index=0&id=68e5d127&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e5d127"]])

export default __exports__